export default __webpack_public_path__ + "static/home-bg-70e37a17790ff702fc7cf4f5835deaf0.webp";